const View = require('public_framework/view')

const tns = require('tiny-slider/dist/tiny-slider')

// Need to be in sync with .sass version
// If you need to modify this, change front/apps/public/shared/styles/mixins/slider.sass too
const BREAKPOINTS = {
  mobile: 0,
  tablet: 524,
  tablet_l: 668,
  desktop_s: 896,
  desktop_m: 1142
}

/**
 * Default options:
 * - No controls("prev / next") buttons
 * - Not possible to drag with mouse
 * - Rewind effect when returning slider
 *
 * Common options:
 * - items = {Integer} Number of slides being displayed.
 * - slideBy = {Integer} Number of slides going on one "click"
 * - controls = {Boolean} Display and functionality of controls (prev/next buttons)
 * - controlsContainer = {Node | String | false} A custom container with your custom prev/next buttons / arrows
 * - nav = {Boolean} Display and functionalities of nav components (dots)
 * - loop = {Boolean} Moves to the first slide with the same direction when reaching the last slide.
 * - disable = {Boolean} Disable slider.
 * - autoplay / autoplayTimeout / autoplayHoverPause / etc
 *
 * More about options / default options here: https://github.com/ganlanyuan/tiny-slider/tree/v2.8.0#options
 *
 * Usage example (options are defined as data attributes):
 * <div class="ui-slider" data-view='ui#slider'
 *                        data-items='1'
 *                        data-screen-mobile='{"items":2}'
 *                        data-screen-desktop_s='{"items":4}'>
 *   <div data-role='slider'>
 *     <div data-role='item'>...</div>
 *     <div data-role='item'>...</div>
 *     <div data-role='item'>...</div>
 *     <div data-role='item'>...</div>
 *     ...
 *   </div>
 * </div>
 *
 * More about the core component: https://github.com/ganlanyuan/tiny-slider/tree/v2.3.11
*/

const DEFAULT_SETTINGS = {
  speed: 600,
  controls: false,
  rewind: true,
  mouseDrag: false
}
const RES_ATTR_REGEXP = /screen(.+)/

class SliderView extends View {
  constructor () {
    super(...arguments)

    const {theme} = this.$el.data()
    this.$el.addClass(theme)

    const settings = this.settings(DEFAULT_SETTINGS)
    // PUB-359: because of the slider layout and tns-slider way of calculating
    // minimum height (https://topt.al/5cQjB), sometimes it's initially set to 0
    // when the slides haven't been laid out yet. I don't want to fix that
    // properly and instead postpone the initialization a bit.
    setTimeout(() => { this.carousel = tns(settings) }, 50)

    this.$el.addClass('is-loaded')
  }

  /**
   * Sets up slider settings using our data attributes and our default settings and returns it
   * @param {Object} defaultSettings - Default settings
   * @return {Object} Final settings with all values
   */
  settings (defaultSettings) {
    const container = this.$('@slider').get(0)
    const dataAttrs = this.$el.data()
    const settings = {container, ...defaultSettings, ...dataAttrs}

    settings.responsive = settings.responsive || {}

    const mediaQueries = Object.keys(dataAttrs).filter(attr => RES_ATTR_REGEXP.test(attr))
    for (let key of mediaQueries) {
      const screenSizeName = key.match(RES_ATTR_REGEXP)[1].toLowerCase()
      const screenSize = BREAKPOINTS[screenSizeName]
      if (typeof screenSize !== 'undefined') {
        settings.responsive[screenSize] = dataAttrs[key]
      }
    }

    return settings
  }
}

module.exports = SliderView



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/slider/views/slider.js